module.exports = __webpack_public_path__ + "assets/img/detail-content-img-2-7b0dc085.jpg";